export default __webpack_public_path__ + "static/media/marc21.a6179475.jpg";